<template>
  <div>
    <b-row class="d-flex align-items-center justify-content-between">
      <b-col cols="6" class="d-flex align-items-center">
        <div
          class="d-flex align-items-center justify-content-center rounded"
          style="background: #e6efff"
        >
          <feather-icon icon="GiftIcon" size="20" style="color: #4d82e6" />
        </div>
        <h4 class="font-weight-bolder text-body ml-1 mb-0 text-nowrap">
          Deposit Matches
        </h4>
      </b-col>

      <b-card
        no-body
        class="text-right"
      >
        <!-- <div class="d-flex align-items-center" style="gap: 8px">
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center" style="gap: 4px">
              <feather-icon
                size="16"
                icon="BarChartIcon"
                style="color: #eab308"
              />
              <p style="color: #eab308">Given:</p>
            </div>
            <p class="font-weight-bolder" style="color: #eab308">
              {{ formatCurrencyBuiltInFunc(1000) }}
            </p>
          </div>
          <div class="d-flex align-items-center" style="gap: 8px">
            <div class="d-flex align-items-center" style="gap: 4px">
              <feather-icon
                size="16"
                icon="BarChartIcon"
                style="color: #22c55e"
              />
              <p style="color: #22c55e">Won:</p>
            </div>
            <p class="font-weight-bolder" style="color: #22c55e">
              {{ formatCurrencyBuiltInFunc(750) }}
            </p>
          </div>
          <div class="d-flex align-items-center" style="gap: 8px">
            <div class="d-flex align-items-center" style="gap: 4px">
              <feather-icon size="16" icon="ZapIcon" style="color: #60a5fa" />
              <p style="color: #60a5fa">Active:</p>
            </div>
            <p class="font-weight-bolder" style="color: #60a5fa">2</p>
          </div>

          <div>
            <b-button
              variant="primary"
              class="text-nowrap"
              @click="handleOpenDepositMatchModal"
            >
              Add Deposit Match
            </b-button>
          </div>
        </div> -->
        <b-button
          variant="primary"
          class="text-nowrap"
          @click="handleOpenDepositMatchModal"
        >
          <!-- <feather-icon icon="PlusIcon" /> -->
          Add Deposit Match
        </b-button>
      </b-card>
    </b-row>

    <b-table
      :items="items"
      :fields="tableDepositColumns"
      responsive
      show-empty
      primary-key="id"
      thead-class="text-nowrap"
      :busy="loadingListPromotion"
    >
      <template #cell(name)="{ item }">
        <div class="d-flex align-items-center" style="gap: 8px">
          <feather-icon icon="SunIcon" style="color: #60a5fa" />
          <p class="text-nowrap">{{ item.name }}</p>
        </div>
      </template>
      <template #cell(dateStartExpired)="{ item }">
        <div class="d-flex align-items-center" style="gap: 8px">
          <feather-icon icon="CalendarIcon" />
          <p class="text-nowrap">
            {{ format(new Date(item.startTime), "dd/MM/yy") }} -
            {{ format(new Date(item.endTime), "dd/MM/yy") }}
          </p>
        </div>
      </template>
      <template #cell(maxAmount)="{ item }">
        <div class="d-flex align-items-center" style="gap: 8px">
          <feather-icon icon="DollarSignIcon" style="color: #4ade80" />
          <span class="text-nowrap">{{ item.maxDiscount || "-" }}</span>
        </div>
      </template>
      <template #cell(deposited)="{ item }">
        <div class="d-flex align-items-center" style="gap: 8px">
          <feather-icon icon="DollarSignIcon" style="color: #4ade80" />
          <span class="text-nowrap">{{ item.totalDeposit || "-" }}</span>
        </div>
      </template>
      <template #cell(bonusGiven)="{ item }">
        <div class="d-flex align-items-center" style="gap: 8px">
          <feather-icon icon="DollarSignIcon" style="color: #4ade80" />
          <span class="text-nowrap">{{ item.totalDiscountUsed || "-" }}</span>
        </div>
      </template>
      <template #cell(lastDateOfDeposit)="{ item }">
        <span class="text-nowrap">{{ item.lastDepositTime || "-" }}</span>
      </template>
      <template #cell(redeemed)="{ item }">
        <span class="text-nowrap">{{ formatStatus(item) }}</span>
      </template>
    </b-table>
    <div
      v-if="paginationPromotions.total > 0"
      class="d-flex align-items-center justify-content-between mt-1"
    >
      <div class="text-muted small">{{ paginationSummary }}</div>
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          v-model="page"
          :total-rows="paginationPromotions.total"
          :per-page="paginationPromotions.limit"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #first-text
            ><span class="text-success">First</span></template
          >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
          <template #last-text><span class="text-info">Last</span></template>
        </b-pagination>
      </b-col>
    </div>
  </div>
</template>

<script>
import { objectProp } from "@/helpers/props";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import {
  BCard,
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BFormSelect,
  BBadge,
  BInputGroup,
  BTable,
  BPagination,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { format } from "date-fns";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    BFormSelect,
    flatPickr,
    ValidationObserver,
    BForm,
    BBadge,
    BInputGroup,
    BTable,
    BInputGroup,
    BFormGroup,
    BPagination,
  },
  props: {
    userData: objectProp(),
  },
  data() {
    return {
      page: 1,
      tableDepositColumns: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "dateStartExpired",
          label: "Date Start/Expire",
        },
        {
          key: "maxAmount",
          label: "Max Amount",
        },
        {
          key: "deposited",
          label: "deposited",
        },
        {
          key: "bonusGiven",
          label: "Bonus Given",
        },
        {
          key: "lastDateOfDeposit",
          label: "Last Date of deposit",
        },
        {
          key: "redeemed",
          label: "Redeemed Status",
        },
      ],
      items: [],
    };
  },
  watch: {
    page() {
      this.fetchDepositMatches();
    },
    reloadListDepositMatches(val) {
      if (val) {
        this.fetchDepositMatches();
        this.setReloadListDepositMatches(false);
      }
    },
    "$route.params.id"() {
      this.fetchDepositMatches();
    },
  },
  computed: {
    ...mapState("user/detail", [
      "loadingListPromotion",
      "paginationPromotions",
    ]),
    ...mapState("promotions/list", ["reloadListDepositMatches"]),
    paginationSummary() {
      const p = this.paginationPromotions || {};
      const page = Number(p.page) || 1;
      const limit = Number(p.limit || p.perPage) || 10;
      const total = Number(p.total) || 0;

      const from = total === 0 ? 0 : (page - 1) * limit + 1;
      const to = total === 0 ? 0 : Math.min(page * limit, total);

      return total === 0
        ? `Showing 0 of 0 items`
        : `Showing ${from} - ${to} of ${total} items`;
    },
  },
  created() {
    this.fetchDepositMatches();
  },
  methods: {
    ...mapActions("user/detail", ["getDepositMatches"]),
    ...mapActions({
      setReloadListDepositMatches:
        "promotions/list/setReloadListDepositMatches",
    }),
    format,
    handleOpenDepositMatchModal() {
      this.$bvModal.show("apply-deposit-match-modal");
    },
    async fetchDepositMatches() {
      const params = {
        userId: this.$route.params.id,
        page: this.page,
      };
      const result = await this.getDepositMatches(params);
      if (result) this.items = result.data || [];
    },
    formatStatus(item) {
      if (!item) return "-";
      if (item.totalDeposit) return "Yes";
      const currentDate = new Date();
      const endDate = new Date(item.endTime);
      return currentDate > endDate ? "No" : "Open";
    },
  },
  setup() {
    return {
      formatCurrencyBuiltInFunc,
    };
  },
};
</script>
